"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get BulkUpdateGoalsRequest () {
        return BulkUpdateGoalsRequest;
    },
    get CreateGoalRequest () {
        return CreateGoalRequest;
    },
    get GoalStatus () {
        return GoalStatus;
    },
    get UpdateGoalRequest () {
        return UpdateGoalRequest;
    }
});
const _zod = require("zod");
const _utilsisomorphic = require("@performyard/utils-isomorphic");
const GoalStatus = _zod.z.enum([
    "archived",
    "done"
]);
const UpdateGoalRequest = _zod.z.object({
    status: GoalStatus.optional(),
    message: _zod.z.string().optional()
});
const BulkUpdateGoalsRequest = _zod.z.object({
    updates: UpdateGoalRequest,
    service: _zod.z.literal("goal")
});
const CreateGoalRequest = _zod.z.object({
    name: _zod.z.string({
        error: (issue)=>issue.input === undefined ? "Name is required" : undefined
    }),
    target: _zod.z.string().optional(),
    units: _zod.z.string(),
    description: _zod.z.string(),
    alignment: _zod.z.string().nullable(),
    categoryIDs: _zod.z.array(_zod.z.any()).optional(),
    categories: _zod.z.array(_zod.z.any()),
    checklist: _zod.z.array(_zod.z.string()),
    startDate: _zod.z.string({
        error: (issue)=>issue.input === undefined ? "Start date is required" : undefined
    }),
    endDate: _zod.z.string().nullable(),
    assignee: _zod.z.string().optional().nullable(),
    transparency: _zod.z.string(),
    isTopGoal: _zod.z.boolean(),
    checklistItems: _zod.z.array(_zod.z.any()).optional(),
    goalWeight: _zod.z.number().or(_zod.z.string()).nullable(),
    value: _zod.z.number().optional(),
    checklistUpdatesGoalProgress: _zod.z.boolean().optional(),
    selectionObjectID: _zod.z.string().optional(),
    reviewReportID: _utilsisomorphic.transformObjectId.optional(),
    reviewReportQuestionIndex: _zod.z.coerce.number().optional(),
    source: _zod.z.string().optional()
});
